//* global window */
import { h } from './element';
import { cssPrefix } from '../config';
import JsBarcode from 'jsbarcode';
import QRCode from 'qrcode';
import { CellRange } from '../core/cell_range';

function resetTextCodeSize() {
  const {
    codeEl, codeOffset,
  } = this;
  let twidth = codeOffset.width;
  codeEl.css('width', `${twidth}px`);
  codeEl.css('height', `${this.rowHeight}px`);
}

function getTextSize(text, fontSize='12px',maxWidth='2000px') {
  //fontSize:代表汉字的大小，英文字会自动按照默认值
  var span = document.createElement("span");
  var result = {};
  span.style.visibility = "hidden";
  span.style.fontSize = fontSize;
  span.style.overflow = "hidden";
  span.style.whiteSpace = "nowrap";
  span.style.textOverflow = "ellipsis";
  span.style.minWidth = "30px";
  span.style.maxWidth = maxWidth;
  span.style.position = "absolute";
  span.style.padding = "0px";
  span.style.marginLeft = "0px";
  document.body.appendChild(span);
  if (typeof span.textContent !== "undefined") {
      span.textContent = text;
  } else {
      span.innerText = text;
  }
  result.width = span.offsetWidth;// - result.width;
  result.height = span.offsetHeight;// - result.height;
  span.parentNode.removeChild(span);
  return result;
};

function keydownEventHandler(evt) {
  console.log("keydownEventHandler......",evt);
  const { keyCode, altKey } = evt;
  if (keyCode !== 13 && keyCode !== 9) evt.stopPropagation();
  if (keyCode === 13 && altKey) {
    insertText.call(this, evt, '\n');
    evt.stopPropagation();
  }
  if (keyCode === 13 && !altKey) evt.preventDefault();
}

function setTextareaRange() {
  const { el } = this.codeEl;
  setTimeout(() => {
    el.focus();
  }, 0);
}

function getConfig(data) {
  const { imageType,ri,ci,config,codeOffset } = this;

  let configKey = ri+'-'+ci+'-key';
  let configObj = data.configInit[imageType];
  if (configObj && codeOffset) {
    configObj.height = codeOffset.height-4;
  }
  
  if (data.config && data.config[configKey] && Object.keys(data.config[configKey]).length>0) {
    if (data.config[configKey][imageType]) {
      configObj = {...data.config[configKey][imageType]};
    }
  }
  if (config && Object.keys(config).length>0) {
    configObj = {...config};
  }
  return configObj
}

function setImage(text, position,data) {
  // console.log('setImage text>>:', text);
  // console.log('setImage position>>:', position);
  let _this = this;
  const { codeEl, textlineEl,imageType,ri,ci,config } = this;
  // console.log('setImage imageType>>:', imageType);
  
  
  //调用条形码、二维码库转换
  if (imageType == 'barcode') { //条形码
    if (!text || text==' '){
      return ;
    }
    let regular = /^[a-zA-Z0-9~!@#$%^&*()_+-<>,./;:]*$/;
    console.log('regular.exec(text) >>:', text.match(regular));
    if (!text.match(regular)){
      return ;
    }

    let configObj = getConfig.call(this,data);
    console.log("configObj......", configObj);
    //计算字体的高度，得出实际条码的高度
    let textHeight = getTextSize(text, configObj.fontSize+'px').height;
    let barcodeHeight = configObj.displayValue?(parseInt(configObj.height)-parseInt(configObj.textMargin)*2-textHeight):(parseInt(configObj.height))
    console.log("parseInt(configObj.margin)......", parseInt(configObj.margin));
    JsBarcode("#"+this.imgId, text, {
      // format: "pharmacode",
      height:barcodeHeight,
      width:parseInt(configObj.width),//线条宽度
      fontSize:parseInt(configObj.fontSize),//字体大小
      font:configObj.font,//字体
      // format: '',//选择要使用的条形码类型
      displayValue: configObj.displayValue,//是否在条形码下方显示文字
      // fontOptions: '',//使文字加粗体或变斜体bold italic
      textAlign: configObj.textAlign,//水平对齐方式 left center right
      textPosition: configObj.textPosition,//设置文本的垂直位置 top bottom
      textMargin: parseInt(configObj.textMargin),//设置条形码和文本之间的间距
      background: configObj.background,//设置条形码的背景
      lineColor: configObj.lineColor,//设置条和文本的颜色。
      margin: parseInt(configObj.margin),//设置条形码周围的空白边距
    });
  } else if (imageType == 'qrcode') {
    QRCode.toDataURL(text.toString(), { errorCorrectionLevel: 'H' }, function (err, url) {
      console.log(url)
      _this.imgEl.attr('src',url)
    })
  } else if (imageType == 'image') {
    _this.imgEl.attr('src',text.toString());
    _this.imgEl.attr('onerror',"this.src='" + require('../../assets/default_icon.png') + "';this.onerror=null")
  } else if (imageType == 'cellimage') {
    let textStr = text.toString();
    var reUrl = /(http|https):\/\/([\w.]+\/?)\S*/;// /^(https|http):\/\/([\w-]+(\.[\w-]+)*\/?)+(\?([\w\-\.,@?^=%&:\/~\+#]*)+)?$/;
    if (reUrl.test(textStr)) {//IsExstsFile(val) && 
      textStr = textStr;
    }else{
      textStr = data.ossUrl+textStr;
    }
    _this.imgEl.attr('src',textStr);
    _this.imgEl.attr('onerror',"this.src='" + require('../../assets/default_icon.png') + "';this.onerror=null")
  }
  setTextareaRange.call(this, position);
}

export default class BarQrCode {
  constructor(ri, ci,imageType, rowHeight,config) {
    this.imageType = imageType; //qrcode:format图二维码 barcode:format条形码 image:format图片 cellimage:单元格图片
    this.ri = ri;
    this.ci = ci;
    this.rowHeight = rowHeight;
    this.config = config;

    this.codeEl = h('div', `${cssPrefix}-barqrcode-area`)
      .children(
        this.imgEl = h('img', 'codeImg')
          // .on('input', evt => inputEventHandler.call(this, evt))
          .on('paste.stop', () => {}),
          // .on('keydown', evt => keydownEventHandler.call(this, evt)),
        this.textlineEl = h('div', 'textline'),
      )
      .on('mousemove.stop', () => {})
      .on('mousedown.stop', () => {});
    this.el = h('div', `${cssPrefix}-barqrcode`)
      .child(this.codeEl).show();
    this.el.setId();
    this.elId = this.el.getId();
    this.imgEl.setId();
    this.imgId = this.imgEl.getId();
    
    console.log('BarQrCode>>:', this.el);

    this.codeOffset = null;
    this.cell = null;
    this.inputText = '';
    this.change = () => {};
    this.oldData = null;
  }

  clear() {
    // const { cell } = this;
    // const cellText = (cell && cell.text) || '';
    if (this.inputText !== '') {
      this.change('finished', this.inputText);
    }
    this.cell = null;
    this.codeOffset = null;
    this.inputText = '';
    this.el.hide();
    this.textlineEl.html('');
    this.imgEl.html('');
    resetSuggestItems.call(this);
    this.datepicker.hide();
  }

  getImgNaturalDimensions(img, callback) {
    var nWidth, nHeight;
    if (img.naturalWidth) { // 现代浏览器
      nWidth = img.naturalWidth;
      nHeight = img.naturalHeight;
      callback(nWidth, nHeight)
    } 
    else { // IE6/7/8
      let image = new Image()
      image.onload = function() {
        callback(image.width, image.height)
      }
      image.src = img.src
    }
  }

  setImageOffset(data,distance) {
    const {
      el,codeEl,imgEl
    } = this;
    if (data) {
      console.log('distance:', distance);
      console.log('data cellRect:', data.cellRect(this.ri,this.ci));
      console.log('data getCellStyle:', data.getCellStyle(this.ri,this.ci));
      let firstCell = data.cellRect(0,0);
      let firstCellRect = data.getRect(new CellRange(0,0,0,0,firstCell.width,firstCell.height));
      // console.log('data cellRect firstCell:', firstCell);
      // console.log('data cellRect00:', data.getRect(new CellRange(0,0,0,0,firstCell.width,firstCell.height)));
      // let oldfirstOffset = this.oldData.cellRect(1,1);
      
      this.codeOffset = data.cellRect(this.ri,this.ci);
      const {
        left, top, width, height
      } = this.codeOffset;
      let border = 1;
      let cellWidth = width-border*2;
      let cellHeight = height-border*2;
      if (width>height) {
        el.offset({ left: left+border+firstCellRect.left , top: top+border+firstCellRect.top ,width: cellHeight, height: cellHeight});
      }else if (width<height) {
        el.offset({ left: left+border+firstCellRect.left , top: top+border+firstCellRect.top ,width: cellWidth, height: cellWidth});
      }else{
        el.offset({ left: left+border+firstCellRect.left , top: top+border+firstCellRect.top ,width: cellWidth, height: cellHeight});
      }
      let config = getConfig.call(this,data);
      let align = (config && config.align) || 'center';//水平对齐方式

      let isZoom = true;//条码实际大小超过单元格大小，是否按比例缩放
      if (config && config.isZoom!=undefined && config.isZoom!=null) {
        isZoom = config.isZoom
      }
      
      let verticalAlign = (config && config.verticalAlign) || 'middle';//垂直对齐方式
      if (align == 'left' || align=='right') {
        align = align=='left'?'flex-start':'flex-end';
      }
      if (verticalAlign == 'top' || verticalAlign=='bottom') {
        verticalAlign = verticalAlign=='top'?'flex-start':'flex-end';
      }
      codeEl.css({justifyContent:align,alignItems:verticalAlign});
      
      if (this.imageType == 'barcode') { //条形码,显示整个单元格
        // left: left+2+firstCellRect.left , top: top+2+firstCellRect.top
        el.offset({ left: left+border+firstCellRect.left , top: top+border+firstCellRect.top ,width: cellWidth, height: cellHeight}); 
        setTimeout(() => {
          this.getImgNaturalDimensions(imgEl.el, (imgWidth,imgHeight)=>{
            console.log("imgEl......",imgEl);
            console.log("imgEl imgWidth......",imgWidth);
            console.log("imgEl imgHeight......",imgHeight);
            if (cellWidth>=imgWidth) {
              if (cellHeight>=imgHeight) {
                imgEl.offset({ width: imgWidth,height: imgHeight});
                imgEl.css({objectFit:'contain'});
              } else {
                if (isZoom) {
                  imgEl.offset({ width: imgWidth*cellHeight/imgHeight,height: cellHeight});
                  imgEl.css({objectFit:'contain'});
                }else{
                  imgEl.offset({ width: imgWidth,height: cellHeight});
                  imgEl.css({objectFit:'fill'});
                }
              }
            }else{
              if (cellHeight>=imgHeight) {
                if (isZoom) {
                  imgEl.offset({ width: cellWidth,height: cellWidth*imgHeight/imgWidth});
                  imgEl.css({objectFit:'contain'});
                }else{
                  imgEl.offset({ width: cellWidth,height: imgHeight});
                  imgEl.css({objectFit:'fill'});
                }
              } else {
                if (isZoom) {
                  if (cellWidth*imgHeight>cellHeight*imgWidth) {
                    imgEl.offset({ width: imgWidth*cellHeight/imgHeight,height: cellHeight});
                  } else {
                    imgEl.offset({ width: cellWidth,height: cellWidth*imgHeight/imgWidth});
                  }
                  imgEl.css({objectFit:'contain'});
                }else{
                  imgEl.offset({ width: cellWidth,height: cellHeight});
                  imgEl.css({objectFit:'fill'});
                }
              }
            }
          })
        }, 0);
      }else{
        el.offset({width: cellWidth, height: cellHeight});
      }
      codeEl.offset({ left: 0, top: 0 });
    }
  }

  setImageCell(cell,data) {
    // console.log('cell>>:', cell);
    const { el } = this;
    el.show();
    this.cell = cell;
    const text = (cell && cell.text) || '';
    this.setImage(text,data);
  }

  setImage(text,data) {
    this.inputText = text;
    // console.log('text>>:', text);
    setImage.call(this, text, text.length,data);
    resetTextCodeSize.call(this);
  }

  showImage(imageType){
    this.imageType = imageType;
    this.el.show();
  }
  hideImage(){
    this.el.hide();
  }
}
